// extracted by mini-css-extract-plugin
module.exports = {"orientationSwitch":"_3npuYPO8LacRalg5iIV3ww","orientationButton":"_2BWwgLNv1KulaVmZgzdDNK","orientationText":"_1OE1UqNZeh8_K_lhVcbQyQ"};